import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Send, Instagram, MessageCircle, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-black text-zinc-400">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo size={26} />
            <p className="mt-4 text-sm text-zinc-500 max-w-xs">
              A trading evaluation and development platform built for synthetic index traders. Prove your edge. Earn performance rewards.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://t.me/tradersspringfunding" target="_blank" rel="noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-md hover:border-white/30 hover:text-white transition" data-testid="footer-telegram-channel">
                <Send size={15} />
              </a>
              <a href="https://t.me/tradersspringgroup" target="_blank" rel="noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-md hover:border-white/30 hover:text-white transition" data-testid="footer-telegram-group">
                <MessageCircle size={15} />
              </a>
              <a href="https://www.instagram.com/tradersspringfunding" target="_blank" rel="noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-md hover:border-white/30 hover:text-white transition" data-testid="footer-instagram">
                <Instagram size={15} />
              </a>
              <a href="mailto:support@tradersspringfunding.com" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-md hover:border-white/30 hover:text-white transition" data-testid="footer-email">
                <Mail size={15} />
              </a>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="label-sm mb-4">Product</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/plans" className="hover:text-white" data-testid="f-plans">Plans</Link></li>
              <li><Link to="/rules" className="hover:text-white" data-testid="f-rules">Rules</Link></li>
              <li><Link to="/affiliate" className="hover:text-white" data-testid="f-affiliate">Affiliate</Link></li>
              <li><Link to="/register" className="hover:text-white" data-testid="f-signup">Start Today</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="label-sm mb-4">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-white" data-testid="f-about">About</Link></li>
              <li><Link to="/faq" className="hover:text-white" data-testid="f-faq">FAQ</Link></li>
              <li><Link to="/terms" className="hover:text-white" data-testid="f-terms">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-white" data-testid="f-privacy">Privacy</Link></li>
              <li><a href="https://t.me/tradersspringgroup" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="f-support">Support</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="label-sm mb-4">Contact</div>
            <p className="text-sm">support@tradersspringfunding.com</p>
            <p className="text-sm mt-1.5">Telegram channel: <a className="text-white hover:text-[#00ff66]" href="https://t.me/tradersspringfunding" target="_blank" rel="noreferrer">@tradersspringfunding</a></p>
            <p className="text-sm mt-1.5">Telegram support: <a className="text-white hover:text-[#00ff66]" href="https://t.me/tradersspringgroup" target="_blank" rel="noreferrer">@tradersspringgroup</a></p>
            <p className="text-sm mt-1.5">Discord: <span className="text-zinc-600">Coming soon</span></p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 space-y-4">
          <div className="text-[11px] text-zinc-500 leading-relaxed max-w-5xl">
            <strong className="text-zinc-300">Legal Disclaimer:</strong> Traders Spring Group is not a broker, financial
            institution, or investment company. We do not accept deposits or manage client funds. All trading activities
            are conducted in simulated environments and are intended for evaluation and educational purposes only. Any
            rewards provided are based on simulated trading performance and adherence to program rules. Traders Spring
            Group utilizes the Deriv demo platform exclusively for evaluation and has no official affiliation with Deriv.
          </div>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div className="text-xs text-zinc-500 font-mono tracking-wider">© {new Date().getFullYear()} TRADERS SPRING GROUP · ALL RIGHTS RESERVED</div>
            <div className="text-xs text-zinc-600">Evaluation · Simulation · Performance Rewards</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
